import generateToast from './ToastGenerator.js';

/** @typedef { import('./clientRequest').Response } ApiResponse */

/**
 *
 * @param {string} url Api url
 * @param {string} value Client phone number
 * @returns
 */
export async function makeRequest(url, value) {
	const params = new URLSearchParams();

	params.append('PHONE', value);

	const { default: axios } = await import("axios");
	const request = axios.post(url, params);

	return request
		.then((response) => {
			/** @type {ApiResponse} */
			const {
				status,
				data: {
					title,
					message,
					name,
				},
			} = response.data;

			if (status && name) {
				generateToast(title, message, '#6EC67B', 'black', true);

				return name;
			} else if (status) {
				generateToast(title, message, '#009996', 'white', true);
			} else {
				generateToast(title, message, '#FF0037', 'white', true);
			}
		})
		.catch((response) => {
			/** @type {ApiResponse} */
			const {
				data: {
					error,
					message,
				},
			} = response.data;

			generateToast(error, message, '#FF0037', 'white', true);

			return Promise.reject(response);
		});
}
